import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { authApi } from '../../api/auth';
import { extractErrorMessage } from '../../api/errors';
import AuthShell from './AuthShell';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const uid = params.get('uid') || '';
  const token = params.get('token') || '';
  const [state, setState] = useState({ status: 'verifying', message: '' });

  useEffect(() => {
    if (!uid || !token) {
      setState({ status: 'invalid', message: 'This link is missing required parameters.' });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        await authApi.confirmEmailVerify({ uid, token });
        if (!cancelled) setState({ status: 'ok', message: '' });
      } catch (err) {
        if (!cancelled) {
          setState({ status: 'invalid', message: extractErrorMessage(err) });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [uid, token]);

  return (
    <AuthShell
      title={state.status === 'ok' ? 'Email verified' : state.status === 'invalid' ? 'Link not valid' : 'Verifying…'}
      subtitle={
        state.status === 'ok'
          ? "Thanks — that's done. You can keep using Atharva as usual."
          : state.status === 'invalid'
            ? state.message || 'This link is invalid or has already been used.'
            : 'Confirming your email with the server.'
      }
      footer={
        <Link to="/login" className="font-medium text-green-700 hover:text-green-800">
          Continue to Atharva
        </Link>
      }
    >
      {state.status === 'verifying' && (
        <p className="text-sm text-gray-500">One moment…</p>
      )}
    </AuthShell>
  );
}
